/*
|-------------------------------------------------------------------------------
| VUEX modules/bookings.js
|-------------------------------------------------------------------------------
| The Vuex data store for the cafes

status = 0 -> data hasn't been loaded
status = 1 -> data is loading
status = 2 -> data is loaded successfully
status = 3 -> data is loaded unsuccessfully
*/

import UserAPI from '../api/user.js';

export const users = {
    state: {
        users: [],
        usersLoadStatus: 0,
    },

    actions: {
        loadUsers( { commit } ) {
            return new Promise((resolve, reject) => {
                commit('setUsersLoadStatus', 1);

                UserAPI.get()
                    .then(response => {
                        commit('setUsers', response.data.data.users.data);
                        commit('setUsersLoadStatus', 2);
                        resolve();
                    })
                    .catch(() => {
                        commit('setUsers', []);
                        commit('setUsersLoadStatus', 3);
                        reject();
                    });
            });
        },
    },

    mutations: {
        setUsers ( state, users ) {
            state.users = users;
        },
        setUsersLoadStatus( state, status ) {
            state.usersLoadStatus = status;
        },
    },

    getters: {
        getUsers ( state ) {
            return state.users;
        },
        getUsersLoadStatus ( state ) {
            return state.usersLoadStatus;
        }
    },
};

/**
 * Helpers
 */

